import { Trophy } from 'lucide-react';
import { useMatches } from '@/data/use-matches';
import { useParticipants } from '@/data/use-participants';
import { ResultsTable } from '@/features/bracket-view/results-table';
import { LoadingState, ErrorState, EmptyState } from '@/components/design';
import type { Tournament } from '@/data/types';

interface Props {
  tournament: Tournament;
}

export function ResultsTab({ tournament }: Props) {
  const { matches, error } = useMatches(tournament.id);
  const { participants } = useParticipants(tournament.id);

  if (error) return <ErrorState title="Не удалось загрузить результаты" body={error.message} />;
  if (matches === undefined || participants === undefined) {
    return <LoadingState />;
  }

  if (matches.length === 0) {
    return (
      <div className="card-d" style={{ padding: 0 }}>
        <EmptyState
          icon={Trophy}
          title="Турнир ещё не начался"
          body="Итоговые места появятся, когда будут сыграны матчи."
        />
      </div>
    );
  }

  return (
    <ResultsTable tournament={tournament} matches={matches} participants={participants} />
  );
}
